import router from "../../../router.js";

export default {
  tipoSelecionado() {
    return router.currentRoute.value.params.tokenTipo;
  },
  lojaSelecionada() {
    return router.currentRoute.value.params.tokenLoja;
  },
  produtoSelecionado() {
    const params = router.currentRoute.value.params;

    // Tenta extrair o código do produto de diferentes formatos de URL
    // 1. URL com slug SEO-friendly: /products/slug-123 -> params.codigo
    if (params.codigo) {
      return params.codigo;
    }

    // 2. URL clássica com codigoProduto: /products/xxx/123 -> params.codigoProduto
    if (params.codigoProduto) {
      return params.codigoProduto;
    }

    // 3. Fallback para URLs antigas com apenas tokenProduto: /products/123
    if (params.tokenProduto) {
      return params.tokenProduto;
    }

    return undefined;
  },
  categoriaSelecionada() {
    return router.currentRoute.value.params.tokenCategoria;
  },
  buscaPesquisada() {
    return router.currentRoute.value.params.tokenBusca;
  },
  paginacao(state) {
    return state.pagina;
  },
};
